import StyleSheet from 'react-native-extended-stylesheet';

export const style = StyleSheet.create({
  ctaButton: {
    marginBottom: '$space4',
  },
});
